import { AppRouteProps } from "@bsm/component";
import { PublicHolidayCreateContainer } from "./container/SchoolHolidayCreateContainer";

export const PublicHolidayCreateRoutes: Array<AppRouteProps> = [
    {
        path: "create",
        title: "BSMRH.Holiday.Create.Title",
        element: <PublicHolidayCreateContainer />,
    },
    {
        path: ":id",
        title: "BSMRH.Holiday.Edit.Title", 
        element: <PublicHolidayCreateContainer />,
    }
];